jQuery(document).ready(function($){
	$('#btn_wrap').hover(
		function(){
			$('#mini_cart').show();
	}, function(){
			$('#mini_cart').hide();
	});

	$('#mini_cart').hover(
		function(){
			$('#mini_cart').show();
	}, function(){
			$('#mini_cart').hide();
	});
});

jQuery(document).ready(function($){
	
});